import React, { useState, useEffect, useRef } from "react";
import { IoMdArrowDropdown } from "react-icons/io";
import { IoSearchSharp } from "react-icons/io5";
import PerfectScrollbar from "react-perfect-scrollbar";
import Pagination from "../components/molecules/Pagination";
import { searchLogs } from "../api/logApi";
import LogModal from "../components/molecules/logModal";
import SortButton from "../components/molecules/sortButton";

interface PageInfo {
  size: number;
  number: number;
  totalElements: number;
  totalPages: number;
}

const Home: React.FC = () => {
  const scrollbarRef = useRef<HTMLElement | null>(null);
  const [searchType, setSearchType] = useState<string>("ip");
  const [failFilter, setFailFilter] = useState<string>("");
  const [keyword, setKeyword] = useState<string>("");
  const [pageInfo, setPageInfo] = useState<PageInfo>({
    size: 10,
    number: 0,
    totalElements: 0,
    totalPages: 0,
  });
  const [currentPage, setCurrentPage] = useState<number>(0); // 현재 페이지
  const [currentSize, setCurrentSize] = useState<number>(10); // 현재 사이즈
  const [logs, setLogs] = useState<any[]>([]);
  const [selectedLog, setSelectedLog] = useState<any>(null);
  const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });
  const [isModalOpen, setIsModalOpen] = useState(false);

  // 정렬 기준
  const [sortState, setSortState] = useState<string>("");

  const handleSortState = (state: string) => {
    setSortState(state);
  };

  const handleRowClick = (event: React.MouseEvent, log: any) => {
    setSelectedLog(log);
    setModalPosition({ x: event.clientX, y: event.clientY });
    setIsModalOpen(true);
  };

  const handleSearchType = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSearchType(event.target.value);
  };

  const handleFailFilter = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setFailFilter(event.target.value);
  };

  /* 검색하기 */
  const handleKeyword = (keyword: string) => {
    setKeyword(keyword);
  };
  //검색창 초기화
  const searchReset = () => {
    setKeyword("");
    setSearchType("ip");
    setFailFilter("");
  };

  // n개씩 보기 드롭다운 핸들러
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setCurrentSize(Number(event.target.value));
    // setPageInfo((prev) => ({ ...prev, size: Number(event.target.value) }));
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      logSearch(true);
    }
  };

  // 페이지 네이션
  const handlePageChange = (page: number) => {
    if (page >= 0 && page < pageInfo.totalPages) {
      setCurrentPage(page);
      // setPageInfo((prev) => ({ ...prev, number: page }));
    }
  };

  useEffect(() => {
    if (currentPage === 0) {
      logSearch();
    }
    setCurrentPage(0);
    if (scrollbarRef.current) {
      scrollbarRef.current.scrollTop = 0; // 스크롤 맨 위로 이동
    }
  }, [currentSize]);

  useEffect(() => {
    logSearch();
    if (scrollbarRef.current) {
      scrollbarRef.current.scrollTop = 0; // 스크롤 맨 위로 이동
    }
  }, [currentPage]);

  const logSearch = async (isSearch: boolean = false) => {
    const data = await searchLogs(isSearch ? 0 : currentPage, currentSize, keyword, searchType);
    if (data) {
      setLogs(data.data.content);
      setPageInfo(data.data.page);
      setCurrentPage(data.data.page.number);
      setCurrentSize(data.data.page.size);
      console.log(data.data);
    }
  };

  return (
    <div
      className="font-NotoSansKR min-h-[88vh] max-h-[88vh] bg-white"
      onClick={() => {
        setIsModalOpen(false);
      }}
    >
      <div className="max-w-[1920px] mx-auto sm:px-2 lg:px-4 py-2">
        <div className="flex gap-6">
          {/* <div className="w-1/2">grafana</div> */}
          <div className="w-full p-4 border border-gray-500 rounded-md shadow-md bg-gray-50">
            {/* 검색 */}
            <div className="mt-4">
              <div className="mb-4">
                <div className="flex flex-col mb-2 space-y-3">
                  <div className="flex items-center space-x-4">
                    <div className="flex-1">
                      <div className="relative">
                        <input
                          type="text"
                          placeholder={`${searchType} 검색`}
                          value={keyword}
                          onChange={(e) => handleKeyword(e.target.value)}
                          className="w-full py-2 pl-10 pr-4 border border-gray-300 rounded-md"
                          onKeyDown={handleKeyDown} // Enter 키 이벤트 처리
                        />
                        <span className="absolute text-gray-400 left-3 top-3">
                          <IoSearchSharp size={20} />
                        </span>
                      </div>
                    </div>

                    <div className="flex space-x-3">
                      <button
                        onClick={() => {
                          logSearch(true);
                        }}
                        className="px-4 py-2 text-white bg-black rounded-md hover:bg-gray-700"
                      >
                        검색
                      </button>
                      <button
                        onClick={() => {
                          searchReset();
                        }}
                        className="px-4 py-2 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                      >
                        초기화
                      </button>
                    </div>
                  </div>

                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex items-center space-x-2">
                        <span className="text-sm text-gray-500">타입:</span>
                        <select
                          className="w-32 px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-custom focus:border-transparent"
                          onChange={handleSearchType}
                          value={searchType}
                        >
                          <option value="ip">IP</option>
                          <option value="username">사용자</option>
                        </select>
                        <span className="text-sm text-gray-500">상태:</span>
                        <select
                          className="w-32 px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-custom focus:border-transparent"
                          onChange={handleFailFilter}
                          value={failFilter}
                        >
                          <option value="">전체</option>
                          <option value="true">성공</option>
                          <option value="false">실패</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  {/* 검색 끝 */}
                </div>
              </div>

              <div className="flex items-center justify-between mb-0">
                <span className="text-sm text-gray-600">총 {pageInfo.totalElements}건</span>
                <div className="relative">
                  <select
                    className="px-4 py-2 pr-8 text-sm bg-white border border-gray-200 rounded-lg appearance-none focus:ring-2 focus:ring-custom focus:border-transparent"
                    value={currentSize}
                    onChange={handleChange}
                  >
                    <option value={10}>10개씩 보기</option>
                    <option value={20}>20개씩 보기</option>
                    <option value={50}>50개씩 보기</option>
                    <option value={pageInfo.totalElements}>전체 보기</option>
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none">
                    <IoMdArrowDropdown />
                  </div>
                </div>
              </div>

              {/* 표 보여주는 것 */}
              <div>
                <PerfectScrollbar containerRef={(ref) => (scrollbarRef.current = ref)}>
                  <div className="min-h-[550px] max-h-[550px]">
                    <table className="min-w-full">
                      <thead className="sticky top-0 z-10">
                        <tr className="bg-gray-200 border-b border-gray-200">
                          <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-black uppercase">
                            <SortButton
                              title="시간"
                              sortState={sortState}
                              sortList={["", ",asc", ",desc"]}
                              handleState={handleSortState}
                            />
                          </th>
                          <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-black uppercase min-w-[10vw] max-w-[10vw]">
                            <SortButton
                              title="IP"
                              sortState={sortState}
                              sortList={["", ",asc", ",desc"]}
                              handleState={handleSortState}
                            />
                          </th>
                          <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-black uppercase min-w-[10vw] max-w-[10vw]">
                            <SortButton
                              title="사용자"
                              sortState={sortState}
                              sortList={["", ",asc", ",desc"]}
                              handleState={handleSortState}
                            />
                          </th>
                          <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-black uppercase min-w-[10vw] max-w-[10vw]">
                            <SortButton
                              title="실행한 기능"
                              sortState={sortState}
                              sortList={["", ",asc", ",desc"]}
                              handleState={handleSortState}
                            />
                          </th>
                          <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-black uppercase">
                            <SortButton
                              title="접근 url"
                              sortState={sortState}
                              sortList={["", ",asc", ",desc"]}
                              handleState={handleSortState}
                            />
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200 round">
                        {logs.map((log) => (
                          <tr
                            key={log.id}
                            className={`relative hover:bg-gray-100 hover:cursor-pointer 
                              ${
                                Math.trunc(log.statusCode / 100) === 2
                                  ? "text-green-500"
                                  : Math.trunc(log.statusCode / 100) === 4
                                  ? "text-yellow-600"
                                  : "text-red-600"
                              }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRowClick(e, log);
                            }}
                          >
                            <td className="px-6 py-4 min-w-[10vw] max-w-[10vw] border-x-2 ">
                              <div className="text-sm truncate">{log.requestTime}</div>
                            </td>
                            <td className="px-6 py-4 min-w-[10vw] max-w-[10vw] border-x-2 ">
                              <div className="text-sm truncate">{log.ip}</div>
                            </td>
                            <td className="px-6 py-4 min-w-[11vw] max-w-[11vw] relative  border-x-2 ">
                              <div className="text-sm truncate">{log.adminUsername}</div>
                            </td>
                            <td className="px-6 py-4 min-w-[11vw] max-w-[11vw] relative  border-x-2 ">
                              <div className="text-sm truncate">{log.apiDescription}</div>
                            </td>
                            <td className="px-6 py-4  min-w-[13vw] max-w-[13vw]">
                              <div className="text-sm truncate">{log.requestUrl}</div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </PerfectScrollbar>
              </div>
            </div>

            <div className="px-6 py-2 border-t border-gray-200">
              <div className="flex items-center justify-center">
                <Pagination
                  currentPage={currentPage}
                  totalPage={pageInfo.totalPages}
                  handlePageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <LogModal log={selectedLog} isOpen={isModalOpen} onClose={setIsModalOpen} position={modalPosition} />
    </div>
  );
};

export default Home;
